export const issueTrackerRuleTypeEnum = {
    Slack: 1,
    Assignee: 2,
    Email: 3,
};

export const issueTrackerRuleTypeList = [
    { id: issueTrackerRuleTypeEnum.Slack, name: 'Slack' },
    { id: issueTrackerRuleTypeEnum.Assignee, name: 'Assignee' },
    { id: issueTrackerRuleTypeEnum.Email, name: 'Email' },
];

export const issueTrackerRuleValueMapping = {
    [issueTrackerRuleTypeEnum.Slack]: 'slackUrl',
    [issueTrackerRuleTypeEnum.Assignee]: 'userId',
    [issueTrackerRuleTypeEnum.Email]: 'email',
};

export const issueTrackerRuleCriteriaFieldEnum = {
    Category: 1,
    LotType: 2,
    Priority: 3,
};

export const issueTrackerRuleCriteriaFieldList = [
    { id: issueTrackerRuleCriteriaFieldEnum.Category, name: 'Category' },
    { id: issueTrackerRuleCriteriaFieldEnum.LotType, name: 'Lot Type' },
    { id: issueTrackerRuleCriteriaFieldEnum.Priority, name: 'Priority' },
];

export const issueTrackerSystemRuleList = [
    { id: 1, name: "Client Rule" },
    { id: 2, name: "System Rule" }
]

export const ruleOperandsEnum = {
    And: 1,
    Or: 2,
};

export const ruleOperands = [
    {
        id: ruleOperandsEnum.And,
        name: 'And',
    },
    {
        id: ruleOperandsEnum.Or,
        name: 'Or',
    }
]

